import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { useAuth } from './AuthProvider.js';

const NoLoggedUser = (props) => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();
  const isOAuthFlow = searchParams.get('oauth');

  if (user && user.isConfirmed && !isOAuthFlow) return <Navigate to="/" />;

  return <>{props.children}</>;
};

export default NoLoggedUser;
